import React from "react";
import { Calendar } from "lucide-react";
import AdminAPI from "../../services/AdminAPI";
import { formatWhen } from "../../Components/approvals/meta";

function EventContent({ detail }) {
  const e = detail.event || {};
  const rows = [
    ["Date", formatWhen(e.start_date)],
    ["Ends", e.end_date ? formatWhen(e.end_date) : ""],
    ["Type", e.event_type],
    ["Location", e.location],
    ["For", (e.student_ids || []).length ? `${e.student_ids.length} selected student(s)` : "All students"],
  ];
  return (
    <div className="rounded-2xl border border-[#e6edf8] bg-white p-4">
      <h3 className="m-0 text-[16px] font-bold text-slate-900">{e.title}</h3>
      {e.description && <p className="mt-1 whitespace-pre-wrap text-[13px] text-slate-600">{e.description}</p>}
      <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-3">
        {rows.map(([k, v]) => (
          <div key={k}>
            <div className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">{k}</div>
            <div className="text-[13px] capitalize text-slate-800">{v || "—"}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export const EVENT_APPROVALS_CONFIG = {
  entityTitle: "Events",
  title: "Event Approvals",
  subtitle: "Review teacher events before students can see them",
  entityLabel: "event",
  entityKey: "event",
  icon: Calendar,
  api: {
    queue: (p) => AdminAPI.approvalsQueue("events", p),
    detail: (id) => AdminAPI.approvalsDetail("events", id),
    review: (id, body) => AdminAPI.approvalsReview("events", id, body),
    bulk: (body) => AdminAPI.approvalsBulk("events", body),
    unpublish: (id) => AdminAPI.approvalsUnpublish("events", id),
  },
  titleOf: (r) => r.title,
  subtitleOf: (r) => [r.event_type, r.location].filter(Boolean).join(" · ") || "Event",
  columns: [
    { key: "title", label: "Event", render: (r) => <span className="font-semibold text-slate-800">{r.title}</span> },
    { key: "date", label: "Date", render: (r) => formatWhen(r.start_date) || "—" },
    { key: "type", label: "Type / place", render: (r) => <span className="capitalize">{[r.event_type, r.location].filter(Boolean).join(" · ") || "—"}</span> },
    { key: "teacher", label: "Created by", render: (r) => r.teacher_name || <span className="text-slate-400">Unknown</span> },
  ],
  renderContent: (detail) => <EventContent detail={detail} />,
};
